import { css } from '@emotion/css';

export const horizontalDivider = css`
  height: 0.1rem;
`;

export const flexN = (n: number) => css`
  flex: ${n};
`;

export const markupContainerStyles = css`
  .markup-container > *:first-child {
    margin-top: 0 !important;
  }

  .markup-container * {
    font-size: 1em;

    ol {
      gap: 0rem;
    }

    li::marker {
      font-size: 1em !important;
    }
    li {
      padding-inline-start: 0;
      margin-top: -1rem;
    }
    li:last-child {
      margin-bottom: 1.4rem;
    }
  }

  .markup-container-lg {
    font-size: 1.4em;
  }

  a {
    word-break: break-all;
    color: var(--link-01);
  }

  pre {
    white-space: pre-wrap;
  }

  .isSingleEmoji {
    span.emoji {
      font-size: 3.2rem;
      vertical-align: bottom;
      line-height: 3.6rem;
    }
  }

  span.emoji {
    font-size: 1.6rem;
    vertical-align: bottom;
  }
`;

export const height100vh = css`
  height: 100vh;
  max-height: 100vh;
`;

export const height100vhMinusHeader = css`
  height: calc(100vh - 5.6rem);
  max-height: calc(100vh - 5.6rem);
`;

export const maxWidth768 = css`
  max-width: 76.8rem;
`;

export const shakeAnimation = css`
  .animate-shake {
    animation: shake 0.15s;
  }

  @keyframes shake {
    0% {
      transform: translate(1px, 1px) rotate(0deg);
    }
    10% {
      transform: translate(-1px, -0.5px) rotate(-0.5deg);
    }
    20% {
      transform: translate(-1px, 0px) rotate(0.5deg);
    }
    30% {
      transform: translate(1px, 0.5px) rotate(0deg);
    }
    40% {
      transform: translate(1px, -1px) rotate(0.5deg);
    }
    50% {
      transform: translate(-1px, 0.5px) rotate(-0.5deg);
    }
    60% {
      transform: translate(-1px, 1px) rotate(0deg);
    }
    70% {
      transform: translate(1px, 1px) rotate(-0.5deg);
    }
    80% {
      transform: translate(-1px, -1px) rotate(0.5deg);
    }
    90% {
      transform: translate(1px, 0.5px) rotate(0deg);
    }
    100% {
      transform: translate(1px, -0.5px) rotate(-0.5deg);
    }
  }
`;

export const placeholderColor = css`
  & > div {
    min-height: auto;
  }
  textarea::placeholder {
    color: var(--text-placeholder);
  }
  textarea {
    padding: 0;
  }
`;

export const lightPurpleBg = css`
  background-color: rgba(246, 246, 255, 1);
`;

export const purpleBorder = css`
  border-color: rgba(190, 197, 241, 1);
`;

export const questionButtonStyles = css`
  // background-color: #f2f2f2; //gray-150 doesn't exist
  background-color: #f8f8f8;
  &:hover {
    background-color: var(--gray-200);
  }

  color: var(--text-info-highlight);
`;

export const entryButton = css`
  border: 1px solid rgb(126, 91, 231);
  background: linear-gradient(
      90deg,
      rgb(126, 91, 231) 0%,
      rgb(186, 79, 223) 67.71%,
      rgb(214, 43, 218) 100%
    )
    padding-box text;
  -webkit-text-fill-color: transparent;
`;

export const mobileHeightAdjustment = css`
  @media (max-width: 768px) {
    height: calc(100vh - 11.4rem) !important;
    max-height: calc(100vh - 11.4rem) !important;
  }
`;

export const iconButtonStyles = css`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  padding: 0;
  &:hover {
    background-color: var(--bg-secondary);
  }
`;
